import React from "react";
import _ from "lodash";
import { Helmet } from "react-helmet";
import VideoJSPlayer from "~/components/VideoPlayer";
import popup from "~/views/Popup/popup";
import { trackEvent } from "~/tools/analytics/cleverTap";
import {
  getVideoInfo,
  addToQueue,
  removeFromQueue
} from "~/redux/uservideo/helpers";
import { onUserAuth } from "~/redux/user/helpers";
import isPast from "date-fns/is_past";
import format from "date-fns/format";
import CountDownPlaceHolder from "./CountDownPlaceHolder";
import Spinner2 from "./Spinner2";
import { AddToFavoritesIcon, RemoveFromFavoritesIcon } from "~/assets/svg";
import stopWatch from '~/assets/images/stop-watch.png'
import get from "lodash/get";
import connect from "~/tools/connect";
import userStore from '~/redux/user/store';

import "./VideoPlayerWithInfo03.scss";

class VideoPlayerWithInfo03 extends React.Component {
  constructor(props) {
    super(props);
    this.data = props.data.contentData[0];
    this.settings = props.data.settings;
    this.state = {
      video: ((props.data || {}).contentData || [])[0],
      isQueued: false,
      user: '',
      tags: _.get(this.data, "tags", []),
      pricingOptions: _.get(props.data, "contentData[0].pricing"),
      showTimer: true,
      isLive: false
    };
  }

  componentDidMount() {
    onUserAuth(() => this.fetchVideoInfo());
    const { isLiveStream } = this.state.video.gist;
    if (
      isLiveStream &&
      this.state.video.gist.scheduleEndDate &&
      !isPast(this.state.video.gist.scheduleEndDate)
    ) {
      this.interval = setInterval(this.checkDone, 1000);
      this.setState({ isLive: true })
    }
  }

  createContainer = () => {
    const wrapper = document.createElement('div')
    const remainingTimeContainer = document.createElement('div')
    const timerIcon = document.createElement('img')
    wrapper.className='remaining-time-wrapper'
    remainingTimeContainer.className='time-elapsed'
    timerIcon.className='timer-icon'
    timerIcon.src = stopWatch
    wrapper.append(timerIcon)
    wrapper.append(remainingTimeContainer)
    return wrapper
  }

  checkDone = () => {
    const { isLiveStream } = this.state.video.gist;
    if (
      isLiveStream &&
      this.state.video.gist.scheduleEndDate &&
      isPast(this.state.video.gist.scheduleEndDate)
    ) {
      clearInterval(this.interval);
      this.setState({ isLiveDone: true, playVideo: false });
    }
  };

  fetchVideoInfo() {
    const id = this.data.gist.id;
    getVideoInfo(id, data =>
      this.setState({ isQueued: data.isQueued, startTime: data.watchedTime })
    );
  }
  addToQueue = () => {
    const { gist = {} } = this.state.video;
    const id = gist.id;
    const contentType = gist.contentType;
    this.setState({ isQueued: null });

    addToQueue(id, contentType, data => {
      var addToQueueEventData = {
        contentId: gist.id,
        contentTitle: gist.title,
        contentType: gist.contentType,
        playbackType: "Streamed",
        networkType: "WiFi"
      };
      trackEvent("Added to Watchlist", addToQueueEventData);
      this.setState({ isQueued: true });
    });
  };

  removeFromQueue = () => {
    const { gist = {} } = this.state.video;
    const id = gist.id;
    this.setState({ isQueued: null });

    removeFromQueue(id, data => {
      var removeFromQueueEventData = {
        contentId: gist.id,
        contentTitle: gist.title,
        contentType: gist.contentType,
        playbackType: "Streamed",
        networkType: "WiFi"
      };
      trackEvent("Removed From Watchlist", removeFromQueueEventData);
      this.setState({ isQueued: false });
    });
  };

  renderHelmet = () => {
    const { gist } = this.data;
    return (
      <Helmet>
        <title>{`${gist.title} | ${window.settings.site}`}</title>
        <meta name="description" content={gist.description} />
        <meta property="og:type" content="video.movie" />
        <meta property="og:title" content={gist.title} />
        <meta property="og:description" content={gist.description} />
        <meta
          property="og:image"
          content={gist.posterImageUrl || gist.videoImageUrl}
        />
      </Helmet>
    );
  };
  renderCountDownPlayer = () => {
    const { gist, contentDetails, parentalRating } = this.data,
      fileType = this.props.layout.settings.fileType,
      startTime = this.state.startTime,
      previewSettings = window.settings.features.free_preview,
      showPreview = previewSettings && previewSettings.isFreePreview,
      previewshowUnit = previewSettings && previewSettings.length.unit,
      previewShowTime =
        previewshowUnit === "Minutes"
          ? parseInt(previewSettings.length.multiplier, 10) * 60
          : parseInt(previewSettings.length.multiplier, 10),
      categoryTitle = _.get(gist.primaryCategory, "title", "")  
    
      
    if(!this.state.user){
      return <div className="video-countdown-player-wrapper">
          <div className="video-module-wrapper">
            <div className="timer">
              <div className="timer-wrapper" style={{ backgroundImage: `url(${gist.imageGist._16x9})` }}>
                {this.state.user !== '' && <div className="login-prompt">
                  <p>Please login to see the video</p>
                  <button className="login-button" onClick={() => popup.login()}>Login</button>
                </div>}
              </div>
            </div>
          </div>
        </div>;
    }  
    return (
      <div className="video-countdown-player-wrapper">
        {gist.scheduleStartDate &&
        !isPast(gist.scheduleStartDate) &&
        !this.state.playVideo ? (
          <div className="video-module-wrapper">
            <div className="timer">
              <div
                className="timer-wrapper"
                style={{ backgroundImage: `url(${gist.imageGist._16x9})` }}
              >
                <CountDownPlaceHolder
                  startTime={gist.scheduleStartDate}
                  displayDetailedTime={true}
                  endTime={gist.scheduleEndDate}
                  closeTimer={() => this.setState({ playVideo: true })}
                />
              </div>
            </div>
          </div>
        ) : this.state.isLiveDone ? (
          <div className="video-module-wrapper">
            <div className="timer">
              <div
                className="timer-wrapper"
                style={{ backgroundImage: `url(${gist.imageGist._16x9})` }}
              >
                <div className="event-done">Event has been finished</div>
              </div>
            </div>
          </div>
        ) : (
          <div className="videojs-player-container">
            <VideoJSPlayer
              {...this.state}
              videoId={gist.id}
              category={categoryTitle}
              fileType={fileType}
              isTrailer={false}
              autoplay={true}
              permalink={gist.permalink}
              previewTime={showPreview && previewShowTime}
              videoTag={_.get(window.settings, "advertising.videoTag")}
              parentalRating={parentalRating}
              showTimer={this.state.showTimer && this.createContainer()}
              isFree={gist.free}
              startTime={startTime}
              closedCaptions={contentDetails.closedCaptions}
              scheduleEndDate={gist.scheduleEndDate}
              isLive={this.state.isLive}
            />
          </div>
        )}
      </div>
    );
  };
  renderSetupInfo = () => {
    const { gist } = this.data;
    const equipment = this.state.tags.filter(t => t.tagType === "equipment");
    return (
      <div className="equipment-setup-info">
        <div
          className="equipment-setup-info-badge"
          style={{ backgroundImage: `url(${get(gist, "badgeImages._1x1")})` }}
        />
        <h3 className="equipment-setup-info-heading">Set-up</h3>
        <div className="equipment-setup-info-list">
          {equipment.length === 0 ||
          equipment[0].title.toLowerCase() === "no equipment necessary" ? (
            <div className="equipment-setup-info-none">
              No Equipment Necessary!
            </div>
          ) : (
            equipment.map(e => {
              const imgURL = get(e, "images._1x1.url");
              return (
                <div className="equipment-setup-info-list-item" key={e.id}>
                  {!!imgURL && (
                    <img src={get(e, "images._1x1.url")} alt={e.title} />
                  )}
                  <span>{e.title}</span>
                </div>
              );
            })
          )}
        </div>
      </div>
    );
  };
  renderVideoInfo = () => {
    const { gist } = this.data,
      { tags } = this.state,
      findTagTitle = str => {
        const tag = tags.find(t => t.tagType === str);
        if (tag) return tag.title;
      },
      duration = findTagTitle("classDuration"),
      details = [
        `Difficulty: ${findTagTitle("difficulty")}`,
        `Playlist: ${findTagTitle("musicType")}`,
        `Rating: ${findTagTitle("rating")}`,
        `${findTagTitle("language")} Language`
      ].filter(s => !s.includes("undefined"));
    return (
      <div className="video-info-detail">
        <div className="video-info-detail-heading-wrapper">
          <h2 className="video-info-detail-duration">{duration}</h2>
          <div className="video-info-detail-favorite">
            {gist.airDateTime && (
              <span>Originally Aired {format(gist.airDateTime, "M/D/YY")}</span>
            )}
            {this.state.user &&
              !gist.isLiveStream &&
              (this.state.isQueued === true ? (
                <div
                  className="video-info-detail-favorite-icon"
                  onClick={this.removeFromQueue}
                >
                  <RemoveFromFavoritesIcon />
                </div>
              ) : this.state.isQueued === false ? (
                <div
                  className="video-info-detail-favorite-icon"
                  onClick={this.addToQueue}
                >
                  <AddToFavoritesIcon />
                </div>
              ) : (
                <div className="video-info-detail-favorite-icon">
                  <Spinner2 />
                </div>
              ))}
          </div>
        </div>
        <p className="video-info-detail-description">{gist.description}</p>
        <div className="video-info-detail-tags">
          {details.map(d => (
            <p key={d}>{d}</p>
          ))}
        </div>
      </div>
    );
  };
  render() {
    return (
      <div className="video-player-with-info-03">
        {this.renderHelmet()}
        {this.renderCountDownPlayer()}
        {this.renderSetupInfo()}
        {this.renderVideoInfo()}
      </div>
    );
  }
}
 
connect(
  VideoPlayerWithInfo03,
  state => ({ user: state.user }),
  userStore
);

export default VideoPlayerWithInfo03;